import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment'; 
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpiringContractsService {
  constructor(private http: HttpClient) {}

  getExpiringContracts(employeeId: string): Observable<any> {
    const apiUrl = `${environment.apiUrl}/hiring/expiring-contracts?employeeId=${employeeId}`;
    return this.http.get<any>(apiUrl);
  }
}